import axios from '@/app/shared/config/interceptor'

const PREFIX = 'dahboard-tv/config-perfil-activities'

export default {
  add (paylod) {
    return axios.post(`${PREFIX}/add`, paylod)
  },
  loadPageFiltered (page, pageSize, filters) {
    return axios.post(`${PREFIX}/paged/?page=${page}&pageSize=${pageSize}`, filters)
  },
  getById (id) {
    return axios.get(`${PREFIX}/${id}`)
  },
  update (id, configPerfilActivities) {
    return axios.put(`${PREFIX}/${id}`, configPerfilActivities)
  },
  delete (id, departaments) {
    return axios.post(`${PREFIX}/${id}`, departaments)
  },
  existProfile () {
    return axios.get(`${PREFIX}/profile`)
  },
  thereIsProfile (id) {
    return axios.get(`${PREFIX}/exist-profile/?departmentId=${id}`)
  }

}
